var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('header-top-nav'),_c('header-search',{on:{"SearchChange":_vm.SearchChange}}),_c('div',{staticClass:"shadow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }